import api from '@/services/api';
import type { Program, ProgramInput } from '@/types/program_schema';

const BASE_URL = '/university/programs';

export const programApi = {
  /**
   * Get all programs
   */
  getAllPrograms: async (params?: {
    page?: number;
    per_page?: number;
    search?: string;
    department_id?: string;
    degree_type?: string;
    is_active?: boolean;
  }) => {
    return api.get<{ data: Program[]; meta?: any }>(BASE_URL, { params });
  },

  /**
   * Get a single program by ID
   */
  getProgramById: async (id: string) => {
    return api.get<{ data: Program }>(`${BASE_URL}/${id}`);
  },

  /**
   * Create a new program
   */
  createProgram: async (input: ProgramInput) => {
    return api.post<{ data: Program }>(BASE_URL, input);
  },

  /**
   * Update an existing program
   */
  updateProgram: async (id: string, input: Partial<ProgramInput>) => {
    return api.put<{ data: Program }>(`${BASE_URL}/${id}`, input);
  },

  /**
   * Delete a program
   */
  deleteProgram: async (id: string) => {
    return api.delete(`${BASE_URL}/${id}`);
  },
};

export default programApi;
